<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>

          <v-layout wrap>
            <v-flex xs8>
              <div class="x-text-field">
                <label>菜单名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs2>
              <div class="x-text-field">
                <label>图标</label>
                <div>{{item.icon}}</div>
              </div>
            </v-flex>

            <v-flex xs2>
              <div class="x-text-field">
                <label>排序</label>
                <div>{{item.rank}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>上级菜单</label>
                <div>{{item.parent ? item.parent.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>路由 Path</label>
                <div>{{item.route}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>功能</label>
                <div>{{item.functions ? item.functions.map(f => f.name).join(", ") : ""}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/menu';

  export default {
    mixins: [mixin.view(baseUri)],
    data() {
      return {
        item: {
          "parent": {"name": null},
          "functions": []
        }
      }
    }
  }
</script>
